var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "workflow-template-grid flex flex-col flex-grow p-4" },
    [
      _c(
        "samc-grid-toolbar",
        [
          _setup.entitledToCreateTaskTemplates
            ? _c(
                "samc-button",
                {
                  staticClass: "mr-[5px]",
                  attrs: { type: "primary" },
                  on: { click: _setup.handleCreateTemplate },
                },
                [_vm._v("Create Template")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("samc-grid", {
        key: "workflowTemplates",
        ref: "grid",
        staticClass: "w-full flex-grow",
        attrs: {
          "defaults-key": "workflow-templates",
          "row-model-type": "clientSide",
          "show-new-expand-icon": "",
          "column-min-width": 80,
        },
        on: {
          overridegridoptions: function ($event) {
            return _setup.overrideGridOptions($event)
          },
        },
      }),
      _vm._v(" "),
      _setup.showTemplateModal
        ? _c(_setup.WorkflowTemplateForm, {
            attrs: {
              template: _setup.selectedTemplate,
              "verification-token": _setup.props.verificationToken,
              "api-root": _setup.props.apiRoot,
            },
            on: {
              saved: _setup.onTemplateSaved,
              cancelled: _setup.onTemplateCancelled,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }